import { FC, useState } from "react";
import styled from "styled-components";
import Colors from "../../../ui/global/Colors";
import Slider from "../../../ui/components/Slider";
import LabelRow from "../../../ui/components/LabelRow";
import InputMicro from "../../../ui/components/InputMicro";
import Fonts from "../../../ui/global/Fonts";
import Button from "../../../ui/components/Button";
import Icon from "../../../ui/global/Icon";
import LabelFrames from "../components/LabelFrames";
import Checkbox from "../../../ui/components/Checkbox";
import { EditBarButton, EditBarCheckbox } from "../components/EditBarItem";
import { AnimateActionType } from "../hooks/useAnimateActions";

const Settings = styled.div.attrs<{ $isMobile?: boolean }>(props => ({
    style: {
        width: props.$isMobile ? '100%' : 'fit-content',
        overflowY: props.$isMobile ? 'auto' : 'hidden',
    },
}))<{ $isMobile?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    gap: 14px;
    min-height: 0;
    overflow-x: hidden;
`;

const SpeedContainer = styled.div.attrs<{ $isMobile?: boolean }>(props => ({
    style: {
        gap: props.$isMobile ? '0px' : '4px',
    },
}))<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 98%;
    // width: ${({ $isMobile }) => $isMobile ? '100%' : '98%'};
`;

const Indent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 4px;
`;

const DimensionInputsContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 4px;
`;

const Toolbar = styled.div.attrs<{ $position: 'top' | 'middle' | 'bottom', $isMobile?: boolean }>(props => ({
    style: {
        alignItems: props.$isMobile ? 'flex-start' : 'flex-end',
        justifyContent: props.$position === 'top' ? 'flex-start' : props.$position === 'middle' ? 'center' : 'flex-end',
    },
}))<{ $position: 'top' | 'middle' | 'bottom', $isMobile?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    flex: 1;
    padding: 0;
    gap: 6px;
    z-index: 100;
    overflow: visible;
`;

const SemiBoldText = styled.p.attrs<{ $isMobile?: boolean }>(props => ({
    style: {
        textAlign: props.$isMobile ? 'left' : 'right',
        margin: props.$isMobile ? '0 0 0 6px' : '0 6px 0 0',
    },
}))<{ $isMobile?: boolean }>`
    display: flex;
    font-family: ${Fonts.lexendSemiBold.fontFamily};
    font-weight: ${Fonts.lexendSemiBold.fontWeight};
    font-size: 13px;
    line-height: 1.2em;
    text-wrap: nowrap;
    color: ${Colors.grey6};
`;

const Divider = styled.div.attrs<{ $isMobile?: boolean }>(props => ({
    style: {
        margin: props.$isMobile ? '4px 0 4px 6px' : '12px 6px 12px 0',
    },
}))<{ $isMobile?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // background-color: ${Colors.grey1};
    height: 1px;
    width: 65%;
`;

const ButtonContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    width: 98%;
    gap: 20px;
    overflow: visible;
`;

interface RightPanelProps {
    isMobile?: boolean;
    animationSpeed: number;
    handleAnimationSpeedChange: (newValue: number) => void;
    frameWidth: number | string;
    frameHeight: number | string;
    handleFrameWidthChange: (newValue: string | number) => void;
    handleFrameHeightChange: (newValue: string | number) => void;
    currentFrameNumber: number;
    maxFrames: number;
    isPlacholder: boolean;
    isPlaying: boolean;
    handleDuplicateCurrentFrame: () => void;
    handleRemoveVideoBackground: () => void;
    handleCropTransparentPixels: () => void;
    currentAction: AnimateActionType | null;
    isFrameHidden: boolean;
    handleToggleFrameVisibility: () => void;
    progress: number;
    message: string;
}

const RightPanel: FC<RightPanelProps> = ({ 
    isMobile,
    animationSpeed, 
    handleAnimationSpeedChange, 
    frameWidth,
    frameHeight,
    handleFrameWidthChange,
    handleFrameHeightChange,
    currentFrameNumber,
    maxFrames,
    isPlacholder,
    isPlaying,
    handleDuplicateCurrentFrame,
    handleRemoveVideoBackground,
    handleCropTransparentPixels,
    currentAction,
    isFrameHidden,
    handleToggleFrameVisibility,
    progress,
    message,
}) => {
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);

    const handleSelectAllClick = (checked: boolean) => {
        setIsSelectAllChecked(checked);
        // console.log(`Select All checked: ${checked}`);
    };

    const disableFrameItems = isPlacholder || currentAction !== null;

    return (
        <Settings $isMobile={isMobile}>

            {/* <Toolbar $position='top' $isMobile={isMobile}>
                <LabelRow
                    label=' '
                    size='default'
                />

                {(maxFrames > 0 && !isPlacholder) && (
                    <SpeedContainer $isMobile={isMobile}>
                        <Indent>
                            <LabelRow 
                                label="Speed" 
                                value={animationSpeed.toString()} 
                                units="(FPS)" 
                                unitsPosition="left"
                                size="mini"
                            />
                        </Indent>
                        <Slider
                            value={animationSpeed}
                            min={1}
                            max={96}
                            step={1}
                            colorMode="light"
                            onChange={(newValue) => handleAnimationSpeedChange(newValue)}
                            showLabel={false}
                        />
                    </SpeedContainer>
                )}
            </Toolbar> */}
            
            <Toolbar id='edit-bar' $position='top' $isMobile={isMobile}>
                {!isMobile && (
                    <LabelRow
                        label=' '
                        size='default'
                    />
                )}

                {(maxFrames > 0 && !isPlacholder) && (
                    <>
                    <SpeedContainer $isMobile={isMobile}>
                        <Indent>
                            <LabelRow 
                                label="Speed" 
                                value={animationSpeed.toString()} 
                                units="(FPS)" 
                                unitsPosition="left"
                                size="mini"
                            />
                        </Indent>
                        <Slider
                            value={animationSpeed}
                            min={1}
                            max={96}
                            step={1}
                            colorMode="light"
                            onChange={(newValue) => handleAnimationSpeedChange(newValue)}
                            showLabel={false}
                        />
                    </SpeedContainer>

                    <Divider $isMobile={isMobile} />
                    </>
                )}

                {/* {(maxFrames > 0 && !isPlacholder) && (
                    <>
                    <SpeedContainer $isMobile={isMobile}>
                        <Indent>
                            <LabelRow 
                                label="Speed" 
                                value={animationSpeed.toString()} 
                                units="(FPS)" 
                                unitsPosition="left"
                                size="mini"
                            />
                        </Indent>
                        <Slider
                            value={animationSpeed}
                            min={1}
                            max={96}
                            step={1}
                            colorMode="light"
                            onChange={(newValue) => handleAnimationSpeedChange(newValue)}
                            showLabel={false}
                        />
                    </SpeedContainer>

                    <Divider $isMobile={isMobile} />
                    </>
                )} */}

                {/* <LabelRow
                    label=' '
                    size='default'
                /> */}
                <SemiBoldText $isMobile={isMobile}>TOOLS</SemiBoldText>
                {/* <LabelFrames currentFrameNumber={currentFrameNumber} maxFrames={maxFrames} /> */}
                <EditBarButton 
                    icon="remove-bg"
                    text="Remove Background" 
                    onClick={handleRemoveVideoBackground}
                    isMobile={isMobile}
                    progress={currentAction === 'remove_background' ? progress : undefined}
                    disabled={disableFrameItems}
                    // progress={0.5}
                    // disabled={true}
                />
                {/* <EditBarButton
                    icon="crop"
                    text='Crop Transparent Pixels'
                    onClick={handleCropTransparentPixels}
                    isMobile={isMobile}
                    progress={currentAction === 'crop_transparent' ? progress : undefined}
                    disabled={disableFrameItems}
                /> */}
                {/* <EditBarButton 
                    icon="crop"
                    text="Crop Images" 
                    onClick={()=>{}}
                    disabled={true}
                /> */}
                {/* <EditBarButton 
                    icon="move"
                    text="move" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="resize"
                    text="scale" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="rotate"
                    text="rotate" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="crop"
                    text="crop" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="flip-horizontal"
                    text="flip horizontal" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="flip-vertical"
                    text="flip vertical" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="duplicate"
                    text="duplicate" // "Clone" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="remove-bg"
                    text="remove background" 
                    onClick={()=>{}}
                />

                <EditBarButton 
                    icon="undo"
                    text="undo" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="redo"
                    text="redo" 
                    onClick={()=>{}}
                />
                <EditBarButton 
                    icon="delete"
                    text="delete" 
                    onClick={()=>{}}
                /> */}

                <Divider $isMobile={isMobile} />

                {!isPlacholder && (
                    <LabelFrames 
                        currentFrameNumber={currentFrameNumber} 
                        maxFrames={isPlacholder ? 0 : maxFrames}
                        isMobile={isMobile}
                    />
                )}
                <EditBarButton 
                    icon={isFrameHidden ? "show" : "hide"}
                    text={isFrameHidden ? "Show Frame" : "Hide Frame"} 
                    onClick={handleToggleFrameVisibility}
                    disabled={disableFrameItems}
                    isMobile={isMobile}
                />
                <EditBarButton 
                    icon="duplicate"
                    text="Duplicate Frame"
                    onClick={handleDuplicateCurrentFrame}
                    disabled={disableFrameItems}
                    isMobile={isMobile}
                />
                {/* <EditBarButton 
                    icon="eye"
                    text="Show / Hide Frame" 
                    onClick={()=>{}}
                    disabled={disableFrameItems}
                /> */}
                {/* <EditBarButton 
                    icon="delete"
                    text="Delete Frame" 
                    onClick={handleDeleteCurrentFrame}
                    disabled={disableFrameItems}
                    isMobile={isMobile}
                /> */}
                <EditBarButton 
                    icon="drag"
                    text="Drag to Reorder Frames"
                    onClick={()=>{}}
                    disabled={true}
                    isMobile={isMobile}
                />

                {/* <Divider />
                <EditBarButton 
                    icon="download"
                    text="EXPORT ANIMATION" 
                    onClick={()=>{}}
                    disabled={disableFrameItems}
                /> */}

                {/* <EditBarCheckbox 
                    text="SELECT ALL:" 
                    checked={isSelectAllChecked}
                    onClick={handleSelectAllClick}
                /> */}
                {/* <LabelFrames 
                    currentFrameNumber={currentFrameNumber} 
                    maxFrames={isPlacholder ? 0 : maxFrames}
                /> */}

                {/* <Divider $isMobile={isMobile} />

                <ButtonContainer>
                    <Button
                        color="black"
                        size="micro"
                        text="Export"
                        // icon="download"
                        fullWidth={true}
                        onClick={() => {}}
                    />
                </ButtonContainer> */}
            </Toolbar>

            {/* <Toolbar $position='bottom'>
                <ButtonContainer>
                    <Button
                        color="black"
                        size="micro"
                        text="Export"
                        // icon="download"
                        fullWidth={true}
                        onClick={() => {}}
                    />
                </ButtonContainer>

                <EditBarCheckbox 
                    text="SELECT ALL:" 
                    checked={isSelectAllChecked}
                    onClick={handleSelectAllClick}
                />
                <LabelFrames 
                    currentFrameNumber={currentFrameNumber} 
                    maxFrames={isPlacholder ? 0 : maxFrames}
                />
            </Toolbar> */}
        </Settings>
    );
};

export default RightPanel;